import type { SpectralWorkspaceSession } from '../types';

export const hasPendingSessionEventParse = (
  sessions: SpectralWorkspaceSession[]
) =>
  sessions.some(
    session =>
      session.status === 'ready' &&
      session.hasHrData !== false &&
      // undefined = metadata only, parse still pending; [] = already parsed, no HR
      session.events == null
  );

export const isWorkspaceChartsDataPending = (
  sessionList: SpectralWorkspaceSession[],
  readySessions: SpectralWorkspaceSession[]
) => {
  if (sessionList.length === 0 || readySessions.length > 0) {
    return false;
  }

  return sessionList.some(
    session => session.hasHrData !== false && session.status !== 'error'
  );
};
